import { Injectable } from '@angular/core';
import { IBehaviorTrackingProvider } from 'app/behavior-tracking/interfaces/behavior-tracking-provider.interface';
import { environment } from 'environments/environment';
// import posthog from 'posthog-js';

@Injectable()
export class PostHogTrackingProviderService implements IBehaviorTrackingProvider {
    public name = 'posthog';

    public constructor() {
        if (!environment.feature.behaviorTrackingAnalytics?.enabled) {
            return;
        }

        const postHogConfig = environment.feature.behaviorTrackingAnalytics?.posthog;
        if (!postHogConfig?.enabled) {
            return;
        }

        // posthog.init(postHogConfig.apiKey, {
        //     api_host: postHogConfig.apiHost,
        //     person_profiles: 'identified_only',
        //     defaults: '2025-05-24',
        //     autocapture: true,
        // });
    }

    public capture(event: string, data: Record<string, unknown> = {}): void {
        // posthog.capture(event, data);
    }

    public identify(userId: string, properties?: Record<string, unknown>): void {
        // posthog.identify(userId, properties);
    }
}
